import { Injectable } from '@angular/core';

interface IropsAccessEntry {
  pnr: string;
  expiresAt: number;
}

const STORAGE_KEY = 'iropsAccessRegistry';
const DEFAULT_TTL_MS = 24 * 60 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class IropsAccessRegistryService {
  register(pnr: string, ttlMs: number = DEFAULT_TTL_MS): void {
    if (!pnr) return;
    const entries = this.readEntries().filter((e) => e.pnr !== pnr);
    entries.push({ pnr, expiresAt: Date.now() + ttlMs });
    this.writeEntries(entries);
  }

  has(pnr: string): boolean {
    if (!pnr) return false;
    return this.readEntries().some((e) => e.pnr === pnr);
  }

  unregister(pnr: string): void {
    if (!pnr) return;
    this.writeEntries(this.readEntries().filter((e) => e.pnr !== pnr));
  }

  private readEntries(): IropsAccessEntry[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw) as IropsAccessEntry[];
      const now = Date.now();
      return Array.isArray(parsed) ? parsed.filter((e) => e?.pnr && e.expiresAt > now) : [];
    } catch {
      return [];
    }
  }

  private writeEntries(entries: IropsAccessEntry[]): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
    } catch {
      // localStorage podria estar deshabilitado o lleno; el flujo no debe romperse
    }
  }
}
